// extracted by mini-css-extract-plugin
module.exports = {"link":"NavLink_link__S_zGV","text":"NavLink_text__5PfTk"};